enum ListPageActionType{
    LIST_PAGE_LOAD_DATA = "LIST_PAGE_LOAD_DATA",
    LIST_PAGE_REQUEST_DATA = "LIST_PAGE_REQUEST_DATA",
    LIST_PAGE_FETCH_MORE_DATA = "LIST_PAGE_FETCH_MORE_DATA",
    LIST_PAGE_APPEND_MORE_DATA = "LIST_PAGE_APPEND_MORE_DATA",
    LIST_PAGE_DISPLAY_ERROR = "LIST_PAGE_DISPLAY_ERROR",
}

export default ListPageActionType;